import { ErrorHandler, LOCALE_ID, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
import { GlobalErrorHandler } from './core/global-error-handler/global-error-handler.service';

registerLocaleData(localeFr);

@NgModule({
  declarations: [AppComponent],
  imports: [CoreModule, AppRoutingModule],
  providers: [
    { provide: LOCALE_ID, useValue: navigator.language || 'fr' },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {}
